const SESSION_STORAGE = {
    DATA: {
        intro: true,
    },
    KEY: "kinioto",
};
export default class Storage {
    constructor() {
        // セッションストレージを取得
        this.data = {
            ...SESSION_STORAGE.DATA,
            ...JSON.parse(sessionStorage.getItem(SESSION_STORAGE.KEY) || "{}"),
        };
    }

    set(prop, val) {
        if (prop && typeof val != "undefined") {
            this.data[prop] = val;
        }

        // セッションストレージを保存
        sessionStorage.setItem(SESSION_STORAGE.KEY, JSON.stringify(this.data));
    }

    get(prop) {
        return this.data[prop];
    }
}
